import * as yup from 'yup';

export const createValidationSchema = (): yup.AnyObjectSchema => {
  return yup.object({
    companyName: yup.string().required('common.not_empty').max(64, 'article.description_maxLen'),
  });
};
